var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.clientCodeList,
                                placeholder: _vm.$t("billingPage.CustomerName"),
                              },
                              model: {
                                value: _vm.queryParams.clientCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "clientCode", $$v)
                                },
                                expression: "queryParams.clientCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SalesOrderToBeApproved.SKU"),
                          prop: "sku",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("SalesOrderToBeApproved.SKU"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.sku,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "sku", $$v)
                            },
                            expression: "queryParams.sku",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessAfterCsgReturn.main.outRefundNo"
                          ),
                          prop: "outRefundNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessAfterCsgReturn.main.outRefundNo"
                            ),
                            comma: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.outRefundNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "outRefundNo", $$v)
                            },
                            expression: "queryParams.outRefundNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CustomerFunction.common.associatedCode"
                          ),
                          prop: "associatedCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "CustomerFunction.common.associatedCode"
                            ),
                            comma: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.associatedCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "associatedCode", $$v)
                            },
                            expression: "queryParams.associatedCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "prohibits",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list":
                              _vm.CSG_RETURN_LIST_ADMIN_OPEN_STATUS,
                            clearable: false,
                            placeholder: _vm.$t("table.statusText"),
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("table.createTimeText") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t("table.createTimeText"),
                          },
                          model: {
                            value: _vm.queryParamsTime_pay,
                            callback: function ($$v) {
                              _vm.queryParamsTime_pay = $$v
                            },
                            expression: "queryParamsTime_pay",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("billingPage.endDate") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: { placeholder: _vm.$t("billingPage.endDate") },
                          model: {
                            value: _vm.queryParamsUpdateTime_pay,
                            callback: function ($$v) {
                              _vm.queryParamsUpdateTime_pay = $$v
                            },
                            expression: "queryParamsUpdateTime_pay",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.CSG_RETURN_LIST_ADMIN_OPEN_STATUS.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDetail(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.common.operate"
                                                )
                                              )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    props.row.status != 1,
                                                  command: "edit",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("editText")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:BusinessAfterReturnConfim",
                                                    arg: "BusinessAfterReturnConfim",
                                                  },
                                                ],
                                                attrs: {
                                                  disabled:
                                                    !props.row.canConfirm,
                                                  command: "confirm",
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.$t("okText")))]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled:
                                                    props.row.status != 1,
                                                  command: "delete",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("delText")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "status-icon": "",
                rules: _vm.rules,
                "label-width": "120px",
                disabled: _vm.disabled,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("serviceItem.table.name"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { maxlength: 20, placeholder: _vm.$t("inputText") },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("serviceItem.table.Serialnumber"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { maxlength: 20, placeholder: _vm.$t("inputText") },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("serviceItem.table.timeConsuming"),
                    prop: "timeConsuming",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { maxlength: 20, placeholder: _vm.$t("inputText") },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }